import "core-js/modules/es6.reflect.construct.js";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
var _excluded = ["antd", "children"];

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import Anchor from './Anchor';
import AntdAnchor from './AntdAnchor';
import AntdAnchorLink from './AntdAnchorLink';

var AnchorWrapper = /*#__PURE__*/function (_Component) {
  _inherits(AnchorWrapper, _Component);

  var _super = _createSuper(AnchorWrapper);

  function AnchorWrapper(props) {
    _classCallCheck(this, AnchorWrapper);

    return _super.call(this, props);
  }

  _createClass(AnchorWrapper, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          antd = _this$props.antd,
          children = _this$props.children,
          other = _objectWithoutProperties(_this$props, _excluded);

      return antd ? /*#__PURE__*/React.createElement(AntdAnchor, other, children) : /*#__PURE__*/React.createElement(Anchor, other, children);
    }
  }]);

  return AnchorWrapper;
}(Component);

AnchorWrapper.Link = AntdAnchorLink;
export default AnchorWrapper;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-anchor/src/index.js